import React from 'react'
import { getAvailablePlans, getUserProfile, updateUserPlan } from './../utils/api'
import { useState } from 'react'
import { useEffect } from 'react'
import { useQuery } from '../utils/query'
import { Link } from 'react-router-dom'

function Profile() {
  const [user, setUser] = useState({ plan: {} })
  const [balance, setBalance] = useState({})
  const [newPlan, setNewPlan] = useState()
  const [plans, setPlans] = useState()
  const userId = useQuery().get('user') || ''

  useEffect(() => {
    if (userId) {
      getPlans()
      fetchUserProfile(userId)
    } else {
    }
  }, [userId])

  const getPlans = async () => {
    const res = await getAvailablePlans()
    if (res.status == 200) {
      setPlans(res.data)
    }
  }

  async function fetchUserProfile(userId) {
    try {
      if (userId) {
        let apiResponse = await getUserProfile({ userId: userId })
        let temp1 = { ...apiResponse.data.user }
        let temp2 = { ...apiResponse.data.balance }
        setUser(temp1)
        setBalance(temp2)
        setNewPlan(temp1.plan?._id)
      } else {
      }
    } catch (error) {
      console.log(error.response.data)
    }
  }

  function dateFormat(date) {
    if (date) {
      return new Date(date)
        .toLocaleString('en-US', {
          timeZone: 'Asia/Kolkata',
        })
        .substr(0, 10)
    }
  }

  const updatePlan = async () => {
    let data = {}
    data['_id'] = user._id
    data['planId'] = newPlan;
    try {
      const res = await updateUserPlan(data)
      if (res.status == 204) {
        // setUser(res.data)
        window.location.reload()
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className="container-fluid emp-profile">
      <div className="row">
        <div className="col-md-3">
          <div className="profile-img">
            <img src={user.profilePic} alt="" />
          </div>
        </div>
        <div className="col-md-9">
          <div className="profile-head">
            <h5>{user.firstName}</h5>
            <div className="row">
              <div className="col-md-4">
                <h5>Status: {user.status} </h5>
                <h5 className='d-flex'>Plan:
                  <select id="inputState" style={{ maxWidth: 200, margin: '0px 2px', border: '1px solid #eee', padding: '0px 2px' }} value={newPlan} name="plan" onChange={(e) => setNewPlan(e.target.value)}>
                    {plans &&
                      plans.map(plan => <option value={plan._id}>{plan.name}</option>)
                    }
                  </select>
                </h5>
                {user?.plan?._id !== newPlan && <h6 style={{ cursor: 'pointer', background: 'linear-gradient(to bottom, #b63137 0%, #b63137 100%)', color: '#fff', display: 'inline-block', padding: '4px 8px', fontWeight: 500, borderRadius: '4px', marginLeft: '50px', marginTop: '-10px' }} onClick={updatePlan}>Update Plan</h6>}
              </div>
              <div className="col-md-4">
                <h5>Activities: {balance.totalActivityCount} </h5>
                <h5>Matches: {balance.totalMatchCount} </h5>
              </div>
              <div className="col-md-4">
                <h5>Likes: {user?.oneTimeAllocation?.likes} </h5>
              </div>
            </div>
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item">
                <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">
                  About
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">
                  Images
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" id="blocked-tab" data-toggle="tab" href="#blocked" role="tab" aria-controls="blocked" aria-selected="false">
                  Blocked
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4">
          <div className="profile-work">
            <p>Things I Love</p>
            {user.thingsYouLove &&
              user.thingsYouLove.map((item, index) => (
                <>
                  <a>{item}</a>
                  <br />
                </>
              ))}
            <p>Things I Hate</p>
            {user.thingsYouHate &&
              user.thingsYouHate.map((item, index) => (
                <>
                  <a>{item}</a>
                  <br />
                </>
              ))}
          </div>
        </div>
        <div className="col-md-8">
          <div className="tab-content profile-tab" id="myTabContent">
            <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
              <div className="row">
                <div className="col-md-6">
                  <label>Name</label>
                </div>
                <div className="col-md-6">
                  <p>{user.firstName}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <label>Gender</label>
                </div>
                <div className="col-md-6">
                  <p>{user.gender}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <label>Interested In</label>
                </div>
                <div className="col-md-6">
                  <p>{user.interestedIn}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <label>Relationship Status</label>
                </div>
                <div className="col-md-6">
                  <p>{user.relationshipStatus}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <label>Date Of Birth</label>
                </div>
                <div className="col-md-6">
                  <p>{dateFormat(user.dateOfBirth)}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <label>Phone</label>
                </div>
                <div className="col-md-6">
                  <p>{user.primaryPhone}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <label>Profession</label>
                </div>
                <div className="col-md-6">
                  <p>{user.profession}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <label>Religion</label>
                </div>
                <div className="col-md-6">
                  <p>{user.religion}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <label>Company Name</label>
                </div>
                <div className="col-md-6">
                  <p>{user.companyName}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <label>Mother Tongue</label>
                </div>
                <div className="col-md-6">
                  <p>{user.motherTongue}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <label>Height</label>
                </div>
                <div className="col-md-6">
                  <p>{user.height}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <label>User's Story</label>
                </div>
                <div className="col-md-6">
                  <p>{user.aboutMe}</p>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
              <div className="container-fluid" style={{ height: '300px', width: '300px', margin: '-20px -10px 0 0' }}>
                <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                  <ol className="carousel-indicators">
                    {user.images &&
                      user.images.map((item, index) => (
                        <li key={index} data-target="#carouselExampleIndicators" data-slide-to={index} className={index === 0 ? 'true' : ''}></li>
                      ))}
                  </ol>
                  <div className="carousel-inner">
                    {user.images &&
                      user.images.map((item, index) => (
                        <div key={index} className={'carousel-item ' + (index === 0 ? 'active' : '')}>
                          <img src={item} className="d-block w-100" alt={item} />
                        </div>
                      ))}
                  </div>
                  <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                  </a>
                  <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="blocked" role="tabpanel" aria-labelledby="blocked-tab">
              <div className="container-fluid" style={{ height: '500px', width: '500px' }}>
                <div className="list-group">
                  {user.blockedBy &&
                    user.blockedBy.map((item, index) => (
                      <Link key={index} to={'/admin/profile?users=' + item._id} className="list-group-item list-group-item-action">
                        {item.firstName}
                      </Link>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Profile }
